import { Outlet } from 'react-router-dom';
import { AppSidebar, useSidebarWidth } from '@/components/AppSidebar';

export function AppLayout() {
  const sidebarWidth = useSidebarWidth();

  return (
    <div className="min-h-screen bg-background">
      {/* Fixed sidebar */}
      <AppSidebar />
      
      {/* Main content with margin offset for sidebar */}
      <main 
        className="h-screen overflow-y-auto transition-all duration-300"
        style={{ marginLeft: sidebarWidth }}
      >
        <Outlet />
      </main>
    </div>
  );
}
